<script>
import Icon from '../Icon.vue';

export default {
  name: 'SpeechToText',
  components: { Icon },
  data() {
    return {
      recognition: undefined,
      enabled: false,
      recording: false,
      error: undefined,
    };
  },

  beforeMount() {
    this.initRecognition();
  },

  methods: {
    getSpeechRecognition() {
      if ('SpeechRecognition' in window) {
        return new SpeechRecognition();
      }

      if ('webkitSpeechRecognition' in window) {
        return new webkitSpeechRecognition();
      }

      return undefined;
    },

    initRecognition() {
      const recognition = this.getSpeechRecognition();

      if (!recognition) {
        this.enabled = false;
        return;
      }

      this.enabled = true;
      this.recognition = recognition;
      this.recognition.interimResults = true;

      this.recognition.onstart = () => {
        this.$emit('startRecognition');
        this.error = undefined;
        this.recording = true;
      };

      this.recognition.onresult = (event) => {
        const results = event.results;
        for (const result of results) {
          for (const alternative of result) {
            this.$emit('result', alternative.transcript);
          }
        }
      };

      this.recognition.onerror = (event) => {
        if (event.error === "no-speech") {
          this.error = "Votre voix n'a pas été détectée, vérifiez que vous avez bien sélectionné le bon micro."
        } else {
          this.error = "Une erreur est survenue"
        }
      };

      this.recognition.onend = () => {
        this.recording = false;
        this.$emit('stopRecognition')
      };
    },

    startRecognition() {
      if (this.recording) {
        return;
      }
      this.recognition.start();
    },
  },
};
</script>

<template>
  <span @click="startRecognition" v-if="enabled" class="p-0.5 border-2 rounded-full relative cursor-pointer"
      :class="[error !== undefined && 'border-red-700', error === undefined && 'border-indigo-600']"
  >
    <Icon class="h-5 w-5 text-indigo-600" name="microphone" v-if="!recording"></Icon>
    <Icon class="h-5 w-5 text-red-700" name="microphone" v-else></Icon>

    <span v-if="error !== undefined" class="absolute min-w-64 z-20 mt-2 shadow-red-light p-4 bg-red-300 text-red-700 border border-1 rounded-md border-red-700">{{error}}</span>
  </span>
</template>